function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuoteIconLeft = function SvgQuoteIconLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.4 13.3",
    style: {
      enableBackground: "new 0 0 13.4 13.3"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 13.3c-.5 0-1-.2-1.5-.7s-.9-1.1-1.2-2C.1 9.8 0 9 0 8.1c0-1.3.2-2.5.7-3.6.4-1.1 1-2.1 1.6-2.8S3.5.3 4.1 0l.9.9v.4c-.5.4-1 1.1-1.5 2-.5.8-.7 1.9-.7 3.3 0 .7.1 1.3.3 1.8.2.3.5.8.9 1.4.3.4.5.7.6.9.1.2.2.5.2.9 0 .6-.2 1-.5 1.3-.2.3-.7.4-1.2.4zm8.5 0c-.6 0-1.1-.2-1.6-.7-.5-.5-.9-1.1-1.2-2-.3-.8-.4-1.6-.4-2.5 0-1.3.2-2.5.7-3.6.4-1.1 1-2.1 1.6-2.8.6-.8 1.2-1.3 1.8-1.6l.9.9v.4c-.5.4-1 1.1-1.5 2-.5.9-.7 2-.7 3.4 0 .7.1 1.3.3 1.8.2.4.5.9 1 1.4.3.4.5.7.6.9.1.2.2.5.2.9 0 .6-.2 1-.5 1.3-.3.1-.7.2-1.2.2z",
    style: {
      fill: "#83bc00"
    }
  }));
};
export default SvgQuoteIconLeft;